 <!-------------About Wellbux Fold Start----------------->
 <div id="about-wellbux" class="about__wellbux__fold" data-aos="fade-up">
    <div class="container">
      <h1>ABOUT WELLBUX</h1>
      <strong>Wellbux helps you stop wasting time and start saving money with thousands of deals at your fingertips.</strong>
      <div class="about__wellbux__video">
        <img src="/assets/images/svg_icons/video.png" width="100%" alt="" />
      </div>
    </div>

  </div>
  <!-------------About Wellbux Fold End----------------->